import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import sellarLogoNew from "../../images/sellar-logo-new.png";
import { TooltipContainer } from "@sellar-io/components";

const BestPricePromiseRoot = ({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) => {
  return (
    <>
      <div className={"m-0 flex shrink-0 cursor-pointer"} onClick={onClick}>
        {children}
      </div>
    </>
  );
};

const FullSize = ({
  showHoverAnimation = true,
  toolTipText,
  showToolTip = true,
}: {
  showHoverAnimation?: boolean;
  showToolTip?: boolean;
  toolTipText?: string;
}) => {
  const content = (
    <div
      className={twMerge(
        "inline-flex h-7 w-[151px] items-center justify-start gap-1.5 rounded-[100px] border border-t-1 border-zinc-300 bg-zinc-100 drop-shadow-[1px_1px_10px_rgba(0,0,0,0.10)]",
        showHoverAnimation &&
          "hover:drop-shadow-[0px_0px_10px_rgba(181,87,241,0.50)]",
      )}
    >
      <Compact className={"-ml-1"} />
      <div className="flex items-center justify-center">
        <div className="text-xs leading-[18px] font-semibold text-zinc-800">
          Best Price Promise
        </div>
      </div>
    </div>
  );

  if (!showToolTip) return content;

  return (
    <TooltipContainer
      enable
      placement="top"
      text={toolTipText ?? "Find out more"}
    >
      {content}
    </TooltipContainer>
  );
};

const Compact = ({ className }: { className?: string }) => {
  return (
    <>
      <div
        className={twMerge(
          "inline-flex h-7 w-7 flex-col items-center justify-center rounded-[100px] border border-zinc-300 bg-white drop-shadow-[1px_0px_4px_rgba(0,0,0,0.10)]",
          className,
        )}
      >
        <img src={sellarLogoNew} className={"h-4 w-4"} />
      </div>
    </>
  );
};

export {
  BestPricePromiseRoot as BestPricePromise,
  FullSize as BestPricePromiseFullSize,
  Compact as BestPricePromiseCompact,
};
